import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { getSiteMode } from './site/siteMode';

const siteMode = getSiteMode();
const SiteApp = React.lazy(() =>
  siteMode === 'admin'
    ? import('./admin/AdminApp')
    : siteMode === 'merchant'
      ? import('./merchant/MerchantApp')
      : import('./App')
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <React.Suspense fallback={(
      <div className="app-shell-loading" role="status" aria-label="正在加载">
        <span className="app-shell-loading-spinner" aria-hidden="true" />
        <span>正在加载</span>
      </div>
    )}>
      <SiteApp />
    </React.Suspense>
  </React.StrictMode>
);
